#import "../fragments/closed-lead-email-automation-fragment.graphql"

query GetClosedLeadEmailAutomation($emailAutomationId: ID!) {
    closedLeadEmailAutomation(id: $emailAutomationId) {
        ...ClosedLeadEmailAutomation
    }
}
